import { render } from "./ProjectEditView.vue?vue&type=template&id=9bd2c8f2"
import script from "./ProjectEditView.vue?vue&type=script&lang=js"
export * from "./ProjectEditView.vue?vue&type=script&lang=js"

import "./ProjectEditView.vue?vue&type=style&index=0&id=9bd2c8f2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__